import { useState, useEffect } from "react";
import { Size, Position, ResizeDirection } from "../types";

export const useWindowResize = (initialSize: Size, position: Position, setPosition: (pos: Position) => void) => {
    const [size, setSize] = useState(initialSize);
    const [isResizing, setIsResizing] = useState(false);
    const [resizeDirection, setResizeDirection] = useState<ResizeDirection>({ x: 0, y: 0 });

    useEffect(() => {
        const handleMouseMove = (e: MouseEvent) => {
            if (isResizing) {
                const newWidth = size.width + e.movementX * resizeDirection.x;
                const newHeight = size.height + e.movementY * resizeDirection.y;

                if (newWidth > 300 && newHeight > 200) {
                    setSize({
                        width: newWidth,
                        height: newHeight,
                    });

                    if (resizeDirection.x === -1) {
                        setPosition({
                            x: position.x + e.movementX,
                            y: position.y,
                        });
                    }

                    if (resizeDirection.y === -1) {
                        setPosition({
                            x: position.x,
                            y: position.y + e.movementY,
                        });
                    }
                }
            }
        };

        const handleMouseUp = () => {
            setIsResizing(false);
        };

        if (isResizing) {
            document.addEventListener("mousemove", handleMouseMove);
            document.addEventListener("mouseup", handleMouseUp);
        }

        return () => {
            document.removeEventListener("mousemove", handleMouseMove);
            document.removeEventListener("mouseup", handleMouseUp);
        };
    }, [isResizing, resizeDirection, size, position, setPosition]);

    const handleResizeStart = (e: React.MouseEvent, x: number, y: number) => {
        e.stopPropagation();
        setIsResizing(true);
        setResizeDirection({ x, y });
    };

    return {
        size,
        setSize,
        handleResizeStart,
    };
};
